module.exports = __webpack_public_path__ + "static/media/close_message.98fcbd46.png";